// with polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';


import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import MultiTab from '@/components/MultiTab';
import i18n from './i18n/i18n';
import Viser from 'viser-vue';
import VueCropper from 'vue-cropper';
import './utils/filter'; // global filter
import { resetFormValidate } from './utils/utils'
import TableTips from '@/components/TableTips'
import SearchForm from '@/components/SearchForm'

import Tmap from '@map-component/vue-tmap';

/*
* 加载表单那设计器
*/
import KFormDesign from './components/k-form-design/packages/index.js'
import './components/k-form-design/styles/form-design.less'
Vue.use(KFormDesign)

import '@/styles/index.scss'

import 'smart-flow-design/lib/smart-flow-design.css'

Vue.use(Viser)
Vue.use(Antd);
Vue.use(Tmap);
Vue.use(VueCropper);


Vue.config.productionTip = false;

Vue.component('TableTips', TableTips)
Vue.component('SearchForm', SearchForm)
Vue.mixin({
  created() {
    if (this.lang && this.form) {
      this.$watch('lang', function(lang) {
        resetFormValidate(this, 'form')
      })
    }
  }
})

// 标签页功能初始化
MultiTab.install(Vue);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
